import { render, staticRenderFns } from "./Devize_de_aprobat_dialog.vue?vue&type=template&id=8c99befc&scoped=true"
import script from "./Devize_de_aprobat_dialog.vue?vue&type=script&lang=js"
export * from "./Devize_de_aprobat_dialog.vue?vue&type=script&lang=js"
import style0 from "./Devize_de_aprobat_dialog.vue?vue&type=style&index=0&id=8c99befc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c99befc",
  null
  
)

export default component.exports